/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskCustomRulesCreate } from "../funcs/riskCustomRulesCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskCustomDetectionRule } from "../models/components/riskcustomdetectionrule.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateCustomDetectionRuleRequest,
  CreateCustomDetectionRuleSecurity,
} from "../models/operations/createcustomdetectionrule.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskCreateCustomDetectionRuleMutationVariables = {
  request: CreateCustomDetectionRuleRequest;
  security?: CreateCustomDetectionRuleSecurity | undefined;
  options?: RequestOptions;
};

export type RiskCreateCustomDetectionRuleMutationData = RiskCustomDetectionRule;

export type RiskCreateCustomDetectionRuleMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createCustomDetectionRule risk
 *
 * @remarks
 * Create a custom regex-backed detection rule for the current project.
 */
export function useRiskCreateCustomDetectionRuleMutation(
  options?: MutationHookOptions<
    RiskCreateCustomDetectionRuleMutationData,
    RiskCreateCustomDetectionRuleMutationError,
    RiskCreateCustomDetectionRuleMutationVariables
  >,
): UseMutationResult<
  RiskCreateCustomDetectionRuleMutationData,
  RiskCreateCustomDetectionRuleMutationError,
  RiskCreateCustomDetectionRuleMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskCreateCustomDetectionRuleMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskCreateCustomDetectionRule(): MutationKey {
  return ["@gram/client", "customRules", "create"];
}

export function buildRiskCreateCustomDetectionRuleMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskCreateCustomDetectionRuleMutationVariables,
  ) => Promise<RiskCreateCustomDetectionRuleMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskCreateCustomDetectionRule(),
    mutationFn: function riskCreateCustomDetectionRuleMutationFn({
      request,
      security,
      options,
    }): Promise<RiskCreateCustomDetectionRuleMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskCustomRulesCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
